import {
  Box,
  Heading,
  Text,
  VStack,
  HStack,
  Icon,
  Input,
  InputGroup,
  InputLeftElement,
  Badge,
} from '@chakra-ui/react'
import { MdSearch } from 'react-icons/md'
import { useState } from 'react'
import PatientsList from './PatientsList'
import PatientFormModal from './PatientFormModal'
import { useTranslation } from 'react-i18next'
import { LuUsers } from 'react-icons/lu'
import { usePatientsList } from '../../api/api_hooks/patients'

export default function PatientsBox() {
  const { t } = useTranslation()
  const { data } = usePatientsList()
  const [search, setSearch] = useState('')

  const total = data?.meta?.total ?? data?.data?.length ?? 0

  return (
    <Box display="flex" flexDirection="column" overflow="hidden" h="100%" bg="gray.50">

      {/* Header gradient */}
      <Box
        bgGradient="linear(135deg, brand.purple 0%, purple.500 50%, pink.400 100%)"
        p={{ base: 5, md: 6 }}
        mb={0}
        boxShadow="lg"
        position="relative"
        overflow="hidden"
        _before={{
          content: '""',
          position: 'absolute',
          top: 0, left: 0, right: 0, bottom: 0,
          background: 'radial-gradient(circle at 30% 20%, rgba(255,255,255,0.18) 0%, transparent 50%)',
          pointerEvents: 'none',
        }}
      >
        <HStack justify="space-between" align="center" position="relative" zIndex={1} mb={4}>
          <HStack spacing={3}>
            <Box p={2.5} bg="whiteAlpha.300" backdropFilter="blur(10px)" borderRadius="xl">
              <Icon as={LuUsers} boxSize={7} color="white" />
            </Box>
            <VStack spacing={0} align="start">
              <HStack spacing={2} align="center">
                <Heading as="h1" size="md" color="white">
                  {t('patient.title')}
                </Heading>
                {total > 0 && (
                  <Badge bg="whiteAlpha.300" color="white" borderRadius="full" px={2} fontSize="xs">
                    {total}
                  </Badge>
                )}
              </HStack>
              <Text fontSize="xs" color="whiteAlpha.800">
                {t('patient.description') || 'Gestion des dossiers patients'}
              </Text>
            </VStack>
          </HStack>
          <PatientFormModal />
        </HStack>

        {/* Search bar — même style que Lab landing */}
        <InputGroup maxW="640px" size="lg" mt={2}>
          <InputLeftElement pointerEvents="none" h="full">
            <MdSearch style={{ color: 'purple', fontSize: '24px' }} />
          </InputLeftElement>
          <Input
            placeholder={t('patient.searchPlaceholder')}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            bg="white"
            borderRadius="xl"
            border="none"
            fontSize="md"
            h="52px"
            pl={12}
            boxShadow="xl"
            _focus={{
              boxShadow: '0 0 0 4px rgba(167, 139, 250, 0.3)',
              transform: 'translateY(-1px)',
            }}
            _placeholder={{ color: 'gray.400' }}
            transition="all 0.2s"
          />
        </InputGroup>
      </Box>

      <Box flex={1} display="flex" flexDirection="column" overflow="hidden">
        <PatientsList search={search} />
      </Box>
    </Box>
  )
}
